import { Routes, RouterModule } from '@angular/router';

//  Route for content layout with sidebar, navbar and footer
// loadChildren: () => import('../../pages/content-pages/content-pages.module').then(m => m.ContentPagesModule)
export const FULL_ROUTES: Routes = [

];
